import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { getHeadingLevel } from 'lib/utils/getHeadingLevel';
import useExperienceEditor from 'lib/utils/use-experience-editor';
import { Foundation } from 'src/.generated/Foundation.EnterpriseWeb.model';
import { applySuperscripts } from 'src/helpers/Superscripts/superscript';
import { useTheme } from 'lib/context/ThemeContext';

export type EyebrowProps = Foundation.EnterpriseWeb.Enterprise.FieldSets.Eyebrow & {
  useTag?: string;
  classes: string;
};

const Eyebrow = ({ fields, useTag, classes }: EyebrowProps): JSX.Element => {
  const isEE = useExperienceEditor();
  const { themeName } = useTheme();
  const isRbaTheme = themeName === 'rba';
  const defaultTag = 'h2';
  const tag = useTag ?? getHeadingLevel(defaultTag, fields?.eyebrowLevel);
  const raw = fields?.eyebrowText?.value ?? '';

  if (!raw && !isEE) {
    return <></>;
  }

  // RBA: process superscripts | AW: use raw text
  const valueToRender = isRbaTheme ? applySuperscripts(raw) : raw;
  const eyebrowField = { value: valueToRender };

  return (
    <div className={classes}>
      {isRbaTheme ? (
        <Text tag={tag} field={eyebrowField} encode={false} />
      ) : (
        <Text tag={tag} field={eyebrowField} />
      )}
    </div>
  );
};

export default Eyebrow;
